// extracted by mini-css-extract-plugin
export var closeButton = "_m1-1";
export var closeX = "_m1-3";
export var container = "_m1-0";
export var image = "_m1-2";